module.exports = __webpack_public_path__ + "static/media/uniform_v1_vs_v2.9c38e8bd.png";